import { useCreateEquipmentConstant } from '_api';
import { ChallengePayload } from '_api/types';
import {
  CheckboxField,
  CreateSelectMultipleField,
  FileInputField,
  InputField,
  MultipleInputField,
  SelectField,
} from 'components/molecules/formFields';
import React, { useState } from 'react';
import { useEquipment, useTargetSide } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { BaseFormProps } from './types';

export const ChallengeForm = ({
  disableAll = false,
  hideSubmitButtons = false,
  initValue,
  onBack,
  onSubmit,
}: BaseFormProps<ChallengePayload>) => {
  const { mutateAsync: createEquipment } = useCreateEquipmentConstant();
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const { equipmentOptions } = useEquipment();
  const { targetSideOptions } = useTargetSide();

  const onAddEquipmentOption = async (option: string) => {
    return await createEquipment({ title: option });
  };

  const formFields = [
    {
      component: InputField,
      fieldKey: 'title',
      label: 'CHALLENGE TITLE',
      required: true,
      xs: 12,
    },
    {
      component: SelectField,
      fieldKey: 'targetSide',
      label: 'TARGET SIDE',
      options: targetSideOptions || [],
      xs: 6,
    },
    {
      component: CreateSelectMultipleField,
      fieldKey: 'equipment',
      label: 'EQUIPMENT NEEDED',
      options: equipmentOptions || [],
      onAddOption: onAddEquipmentOption,
      required: true,
      xs: 6,
    },
    {
      component: InputField,
      fieldKey: 'description',
      label: 'FUNCTIONAL CHALLENGE DESCRIPTION',
      multiline: true,
      rows: 4,
    },
    {
      component: MultipleInputField,
      fieldKey: 'instructionList',
      label: 'INSTRUCTION LIST',
      xs: 12,
    },
    {
      component: FileInputField,
      fieldKey: 'imageUrl',
      label: 'THUMBNAIL IMAGE',
      isUploadingFile: (uploading: boolean) => setIsUploadingFile(uploading),
      xs: 6,
    },
    {
      component: FileInputField,
      fieldKey: 'videoLink',
      label: 'VIDEO LINK',
      acceptFileType: 'video/mp4,video/webm,video/ogg',
      isUploadingFile: (uploading: boolean) => setIsUploadingFile(uploading),
      xs: 6,
    },
    {
      component: CheckboxField,
      fieldKey: 'shareWithOrg',
      label: 'SHARE',
      checkboxLabel: 'Share with Your Organization',
      xs: 4,
    },
  ];

  return (
    <FormBuilder
      disabled={disableAll}
      disableSubmit={isUploadingFile}
      initValues={initValue}
      formFields={formFields}
      onBack={onBack}
      onSubmit={onSubmit}
      hideSubmit={hideSubmitButtons}
    />
  );
};
